import script from "./DesingsCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesingsCards.vue?vue&type=script&setup=true&lang=ts"

import "./DesingsCards.vue?vue&type=style&index=0&id=23a3c9d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23a3c9d1"]])

export default __exports__